import axios from 'axios'

export const state = {
  cachedEdges: null,
  selectedEdge: null,
}

export const getters = {
  cachedEdges(state) {
    return state.cachedEdges
  },

  selectedEdge(state) {
    return state.selectedEdge
  },
}

export const mutations = {
  SET_CACHE(state, edges) {
    state.cachedEdges = edges
  },

  SET_SELECTED(state, edge) {
    state.selectedEdge = edge
  },
}

export const actions = {
  selectEdge({ commit, state, rootState }, { edge }) {
    commit('SET_SELECTED', edge)
  },

  edgeById({ commit, state, rootState }, { edgeId }) {
    let edge = state.cachedEdges.filter((edge) => edge.id === parseInt(edgeId, 10))[0]
    return Promise.resolve(edge)
  },

  fetchEdges({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedEdges the user.
    const cachedEdges = state.cachedEdges
    if (!clearCache && cachedEdges) {
      return Promise.resolve(cachedEdges)
    }

    // 2. Fetch the edges from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/Edge/GetAll')
      .then((response) => {
        const edges = response.data.items
        if (edges.length > 0) {
          commit('SET_CACHE', edges)
        }
        return edges
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateEdge({ commit, dispatch, state, rootState }, { edge }) {
    return axios
      .put('/api/services/app/Edge/Update', edge)
      .then((response) => {
        dispatch('fetchEdges', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
